var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 3",
    opacity: 0.202683,
    cx: 101,
    cy: 101,
    r: 101,
    transform: "matrix(0 -1 -1 0 202 202)",
    fill: "url(#paint0_linear_575_2441)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "toronto_flatline 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "toronto_flatline"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 126.429,
    y: 172.025,
    width: 47.2303,
    height: 65.0554,
    transform: "rotate(-180 126.429 172.025)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.211 172.359H126.435C126.523 172.36 126.608 172.326 126.67 172.263C126.732 172.199 126.765 172.113 126.762 172.025V106.951C126.762 106.773 126.618 106.63 126.441 106.63H79.211C79.0341 106.63 78.8906 106.773 78.8906 106.951V172.038C78.8906 172.215 79.0341 172.359 79.211 172.359ZM126.114 171.717H79.5251V107.29H126.114V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M124.34 114.594H81.2941C81.1171 114.594 80.9736 114.451 80.9736 114.274C80.977 114.098 81.1185 113.957 81.2941 113.953H124.34C124.517 113.953 124.66 114.097 124.66 114.274C124.66 114.359 124.626 114.44 124.566 114.5C124.506 114.561 124.425 114.594 124.34 114.594Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M124.34 121.699H81.2941C81.1185 121.696 80.977 121.554 80.9736 121.379C80.9736 121.202 81.1171 121.058 81.2941 121.058H124.34C124.517 121.058 124.66 121.202 124.66 121.379C124.66 121.464 124.626 121.545 124.566 121.605C124.506 121.666 124.425 121.699 124.34 121.699Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M124.34 128.798H81.2941C81.1185 128.795 80.977 128.653 80.9736 128.477C80.9736 128.3 81.1171 128.157 81.2941 128.157H124.34C124.517 128.157 124.66 128.3 124.66 128.477C124.66 128.562 124.626 128.644 124.566 128.704C124.506 128.764 124.425 128.798 124.34 128.798Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M124.34 135.897H81.2941C81.1171 135.897 80.9736 135.753 80.9736 135.576C80.9736 135.399 81.1171 135.255 81.2941 135.255H124.34C124.517 135.255 124.66 135.399 124.66 135.576C124.66 135.753 124.517 135.897 124.34 135.897Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M124.34 142.996H81.2941C81.1171 142.996 80.9736 142.852 80.9736 142.675C80.977 142.499 81.1185 142.358 81.2941 142.354H124.34C124.517 142.354 124.66 142.498 124.66 142.675C124.66 142.76 124.626 142.842 124.566 142.902C124.506 142.962 124.425 142.996 124.34 142.996Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M124.34 150.101H81.2941C81.1185 150.097 80.977 149.956 80.9736 149.78C80.9736 149.603 81.1171 149.459 81.2941 149.459H124.34C124.517 149.459 124.66 149.603 124.66 149.78C124.66 149.865 124.626 149.947 124.566 150.007C124.506 150.067 124.425 150.101 124.34 150.101Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M124.34 157.199H81.2941C81.1185 157.196 80.977 157.054 80.9736 156.879C80.9736 156.702 81.1171 156.558 81.2941 156.558H124.34C124.517 156.558 124.66 156.702 124.66 156.879C124.66 156.964 124.626 157.045 124.566 157.105C124.506 157.166 124.425 157.199 124.34 157.199Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M124.34 164.298H81.2941C81.1171 164.298 80.9736 164.154 80.9736 163.977C80.9736 163.8 81.1171 163.657 81.2941 163.657H124.34C124.517 163.657 124.66 163.8 124.66 163.977C124.66 164.154 124.517 164.298 124.34 164.298Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 126.435,
    y: 106.963,
    width: 40.2066,
    height: 3.75776,
    transform: "rotate(-180 126.435 106.963)",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2218 107.291H126.435C126.523 107.289 126.606 107.252 126.666 107.188C126.727 107.124 126.759 107.039 126.755 106.951V103.212C126.755 103.035 126.612 102.892 126.435 102.892H86.2218C86.0448 102.892 85.9014 103.035 85.9014 103.212V106.97C85.9048 107.146 86.0463 107.287 86.2218 107.291ZM126.114 106.649H86.5422V103.533H126.114V106.649Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 56.9673,
    y: 123.751,
    width: 13.1565,
    height: 48.2673,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9674 172.358H70.1239C70.2124 172.359 70.2969 172.322 70.3576 172.258C70.4183 172.194 70.4497 172.107 70.4444 172.019V123.751C70.4444 123.574 70.3009 123.431 70.1239 123.431H56.9674C56.7919 123.434 56.6504 123.576 56.647 123.751V172.038C56.647 172.215 56.7904 172.358 56.9674 172.358ZM69.8227 171.717H57.307L57.2878 124.072H69.8227V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 31.6733,
    y: 117.608,
    width: 25.7299,
    height: 54.417,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6734 172.359H57.4226C57.5099 172.359 57.5934 172.323 57.6538 172.26C57.7143 172.197 57.7465 172.112 57.743 172.025V117.608C57.743 117.431 57.5996 117.288 57.4226 117.288H31.6734C31.4965 117.288 31.353 117.431 31.353 117.608V172.038C31.353 172.215 31.4965 172.359 31.6734 172.359ZM57.1022 171.717H32.0131L31.9939 117.929H57.1022V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M56.2626 124.04H32.8141C32.6371 124.04 32.4937 123.897 32.4937 123.72C32.4937 123.542 32.6371 123.399 32.8141 123.399H56.2626C56.4396 123.399 56.583 123.542 56.583 123.72C56.583 123.897 56.4396 124.04 56.2626 124.04Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M56.2626 129.985H32.8141C32.6371 129.985 32.4937 129.841 32.4937 129.664C32.4937 129.487 32.6371 129.343 32.8141 129.343H56.2626C56.4396 129.343 56.583 129.487 56.583 129.664C56.583 129.841 56.4396 129.985 56.2626 129.985Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M56.2626 135.923H32.8141C32.6371 135.923 32.4937 135.779 32.4937 135.602C32.4937 135.425 32.6371 135.281 32.8141 135.281H56.2626C56.4396 135.281 56.583 135.425 56.583 135.602C56.583 135.779 56.4396 135.923 56.2626 135.923Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M56.2626 141.86H32.8141C32.6371 141.86 32.4937 141.717 32.4937 141.54C32.4937 141.363 32.6371 141.219 32.8141 141.219H56.2626C56.4396 141.219 56.583 141.363 56.583 141.54C56.583 141.717 56.4396 141.86 56.2626 141.86Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M56.2626 147.798H32.8141C32.6371 147.798 32.4937 147.655 32.4937 147.478C32.4937 147.301 32.6371 147.157 32.8141 147.157H56.2626C56.4396 147.157 56.583 147.301 56.583 147.478C56.583 147.655 56.4396 147.798 56.2626 147.798Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M56.2626 153.762H32.8141C32.6371 153.762 32.4937 153.619 32.4937 153.442C32.4937 153.265 32.6371 153.121 32.8141 153.121H56.2626C56.4396 153.121 56.583 153.265 56.583 153.442C56.583 153.619 56.4396 153.762 56.2626 153.762Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M56.2626 159.674H32.8141C32.6371 159.674 32.4937 159.531 32.4937 159.354C32.4937 159.177 32.6371 159.033 32.8141 159.033H56.2626C56.4396 159.033 56.583 159.177 56.583 159.354C56.583 159.531 56.4396 159.674 56.2626 159.674Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M56.2626 165.612H32.8141C32.6371 165.612 32.4937 165.469 32.4937 165.292C32.4937 165.115 32.6371 164.971 32.8141 164.971H56.2626C56.4396 164.971 56.583 165.115 56.583 165.292C56.583 165.469 56.4396 165.612 56.2626 165.612Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 31.6733,
    y: 114.466,
    width: 21.9041,
    height: 3.14215,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6734 117.929H53.5775C53.7545 117.929 53.898 117.785 53.898 117.608V114.466C53.898 114.289 53.7545 114.146 53.5775 114.146H31.6734C31.4965 114.146 31.353 114.289 31.353 114.466V117.608C31.353 117.785 31.4965 117.929 31.6734 117.929ZM53.2571 117.288H31.9939V114.787H53.2571V117.288Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 64.6831,
    y: 128.035,
    width: 2.42239,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    x: 60.4346,
    y: 135.05,
    width: 2.42239,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    x: 63.459,
    y: 141.713,
    width: 2.42239,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M93.5149 157.417C87.5614 147.895 72.4055 141.123 54.6476 141.123C36.8898 141.123 21.7403 147.895 15.7676 157.417H93.5149Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7674 157.712H93.5148C93.5919 157.689 93.6565 157.636 93.6942 157.565C93.7455 157.471 93.7455 157.357 93.6942 157.264C87.5741 147.433 71.8286 140.828 54.6026 140.828C37.3767 140.828 21.6568 147.433 15.5111 157.264C15.4559 157.356 15.4559 157.472 15.5111 157.565C15.5639 157.656 15.6617 157.713 15.7674 157.712ZM92.9765 157.129H16.3186C22.5604 147.709 37.8574 141.418 54.6475 141.418C71.4376 141.418 86.741 147.709 92.9765 157.129Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M92.1818 162.535H19.0613L15.8892 157.27H93.4122L92.1818 162.535Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0614 162.855H92.1818C92.3416 162.869 92.4867 162.762 92.5214 162.605L93.7455 157.34C93.7687 157.247 93.7474 157.147 93.6878 157.071C93.6253 156.994 93.531 156.949 93.4314 156.949H15.8892C15.775 156.949 15.6695 157.01 15.6136 157.11C15.5565 157.211 15.5565 157.335 15.6136 157.437L18.7858 162.701C18.8443 162.797 18.9489 162.856 19.0614 162.855ZM91.9254 162.214H19.2408L16.4595 157.59H93.0021L91.9254 162.214Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 17.3184,
    y: 162.535,
    width: 76.0875,
    height: 9.49058,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3185 172.358H93.406C93.583 172.358 93.7264 172.215 93.7264 172.038V162.547C93.7264 162.37 93.583 162.227 93.406 162.227H17.3185C17.1415 162.227 16.998 162.37 16.998 162.547V172.038C16.998 172.215 17.1415 172.358 17.3185 172.358ZM93.0856 171.717H17.6389V162.868H93.0856V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M87.5808 158.514C82.6591 150.639 70.1306 145.047 55.4552 145.047C40.7799 145.047 28.2449 150.646 23.3232 158.514H87.5808Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3232 158.802H87.5807C87.6841 158.801 87.779 158.745 87.8307 158.655C87.882 158.563 87.882 158.452 87.8307 158.36C82.7424 150.216 69.7332 144.746 55.4552 144.746C41.1772 144.746 28.1616 150.216 23.0733 158.36C23.0167 158.45 23.0139 158.563 23.0661 158.656C23.1184 158.748 23.2171 158.805 23.3232 158.802ZM87.0424 158.251H23.8615C29.0396 150.492 41.6386 145.368 55.4552 145.368C69.2718 145.368 81.8644 150.556 87.0424 158.251Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9614 158.835H78.9418C79.0636 158.846 79.1817 158.789 79.2494 158.687C79.3006 158.591 79.3006 158.476 79.2494 158.379C75.5132 150.21 65.9647 144.721 55.474 144.721C44.9834 144.721 35.4284 150.21 31.6923 158.379C31.641 158.476 31.641 158.591 31.6923 158.687C31.7527 158.777 31.8531 158.832 31.9614 158.835ZM78.4355 158.193H32.4677C36.2743 150.498 45.4128 145.368 55.4548 145.368C65.4968 145.368 74.6609 150.498 78.4355 158.193Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8245 158.835H69.0796C69.18 158.833 69.2742 158.786 69.336 158.706C69.3944 158.627 69.4133 158.526 69.3872 158.431C67.2148 150.229 61.6202 144.721 55.4553 144.721C49.2903 144.721 43.6893 150.229 41.5169 158.431C41.4908 158.526 41.5097 158.627 41.5681 158.706C41.6299 158.786 41.7241 158.833 41.8245 158.835ZM68.6631 158.193H42.241C44.4135 150.498 49.6941 145.368 55.4553 145.368C61.2165 145.368 66.4906 150.498 68.6631 158.193Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3923 158.835H59.5118C59.6014 158.834 59.6869 158.797 59.7489 158.732C59.8076 158.665 59.8375 158.577 59.8322 158.488C59.3003 151.832 57.9161 144.721 55.4553 144.721C52.9944 144.721 51.5974 151.832 51.0719 158.488C51.0666 158.577 51.0965 158.665 51.1552 158.732C51.2172 158.797 51.3027 158.834 51.3923 158.835ZM59.1658 158.193H51.7384C52.4433 149.767 54.1351 145.368 55.4553 145.368C56.7754 145.368 58.4608 149.767 59.1658 158.193Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M86.4782 162.74H24.4251L23.4126 158.386H87.4907L86.4782 162.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4252 163.06H86.4782C86.6309 163.064 86.7651 162.959 86.7986 162.81L87.8112 158.463C87.8345 158.367 87.8133 158.265 87.7535 158.187C87.691 158.109 87.5967 158.064 87.4972 158.065H23.4127C23.3147 158.063 23.2219 158.109 23.1627 158.187C23.1007 158.264 23.0771 158.366 23.0986 158.463L24.1112 162.81C24.1442 162.957 24.2748 163.061 24.4252 163.06ZM86.2027 162.419H24.6815L23.8164 158.706H87.0678L86.2027 162.419Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    x: 23.4126,
    y: 162.74,
    width: 64.0845,
    height: 9.28538,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4066 172.32H87.4911C87.5693 172.32 87.6443 172.289 87.6996 172.234C87.7548 172.178 87.7859 172.103 87.7859 172.025V162.74C87.7859 162.577 87.6539 162.445 87.4911 162.445H23.4066C23.2438 162.445 23.1118 162.577 23.1118 162.74V172.025C23.1118 172.188 23.2438 172.32 23.4066 172.32ZM87.2027 171.717H23.7014V163.035H87.2027V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M87.0807 160.886H25.6173C25.4403 160.886 25.2969 160.743 25.2969 160.566C25.2969 160.389 25.4403 160.245 25.6173 160.245H87.0807C87.2577 160.245 87.4012 160.389 87.4012 160.566C87.4012 160.743 87.2577 160.886 87.0807 160.886Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    x: 25.9121,
    y: 165.35,
    width: 12.1761,
    height: 6.67547,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9186 172.359H38.0946C38.1819 172.359 38.2654 172.323 38.3259 172.26C38.3863 172.198 38.4185 172.113 38.415 172.025V165.35C38.4116 165.174 38.2702 165.033 38.0946 165.029H25.9186C25.743 165.033 25.6016 165.174 25.5981 165.35V172.038C25.5981 172.215 25.7416 172.359 25.9186 172.359ZM37.7678 171.718H26.2326V165.683H37.7678V171.718Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M29.0265 172.359C28.8495 172.359 28.7061 172.215 28.7061 172.038V165.35C28.7061 165.173 28.8495 165.029 29.0265 165.029C29.2034 165.029 29.3469 165.173 29.3469 165.35V172.025C29.3504 172.113 29.3182 172.198 29.2577 172.26C29.1972 172.323 29.1137 172.359 29.0265 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M32.0065 172.359C31.8295 172.359 31.686 172.215 31.686 172.038V165.35C31.686 165.173 31.8295 165.029 32.0065 165.029C32.182 165.033 32.3235 165.174 32.3269 165.35V172.025C32.3304 172.113 32.2982 172.198 32.2377 172.26C32.1772 172.323 32.0937 172.359 32.0065 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    d: "M34.9928 172.359C34.8158 172.359 34.6724 172.215 34.6724 172.038V165.35C34.6758 165.174 34.8173 165.033 34.9928 165.029C35.1698 165.029 35.3132 165.173 35.3132 165.35V172.025C35.3167 172.113 35.2845 172.198 35.224 172.26C35.1635 172.323 35.08 172.359 34.9928 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 41.5488,
    y: 165.35,
    width: 12.1761,
    height: 6.67547,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5484 172.359H53.7245C53.8118 172.359 53.8953 172.323 53.9557 172.26C54.0162 172.198 54.0484 172.113 54.0449 172.025V165.35C54.0449 165.173 53.9015 165.029 53.7245 165.029H41.5484C41.3715 165.029 41.228 165.173 41.228 165.35V172.038C41.228 172.215 41.3715 172.359 41.5484 172.359ZM53.4041 171.718H41.8689V165.683H53.4041V171.718Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M44.6568 172.359C44.4799 172.359 44.3364 172.215 44.3364 172.038V165.35C44.3398 165.174 44.4813 165.033 44.6568 165.029C44.8338 165.029 44.9773 165.173 44.9773 165.35V172.025C44.9808 172.113 44.9485 172.198 44.8881 172.26C44.8276 172.323 44.7441 172.359 44.6568 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    d: "M47.6368 172.359C47.4599 172.359 47.3164 172.215 47.3164 172.038V165.35C47.3164 165.173 47.4599 165.029 47.6368 165.029C47.8138 165.029 47.9573 165.173 47.9573 165.35V172.025C47.9607 172.113 47.9285 172.198 47.8681 172.26C47.8076 172.323 47.7241 172.359 47.6368 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M50.6168 172.359C50.4398 172.359 50.2964 172.215 50.2964 172.038V165.35C50.2964 165.173 50.4398 165.029 50.6168 165.029C50.7923 165.033 50.9338 165.174 50.9372 165.35V172.025C50.9407 172.113 50.9085 172.198 50.848 172.26C50.7876 172.323 50.7041 172.359 50.6168 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    x: 57.1787,
    y: 165.35,
    width: 12.1761,
    height: 6.67547,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1788 172.359H69.3549C69.4421 172.359 69.5256 172.323 69.5861 172.26C69.6466 172.198 69.6788 172.113 69.6753 172.025V165.35C69.6753 165.173 69.5318 165.029 69.3549 165.029H57.1788C57.0019 165.029 56.8584 165.173 56.8584 165.35V172.038C56.8584 172.215 57.0019 172.359 57.1788 172.359ZM69.0345 171.718H57.4992V165.683H69.0345V171.718Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M60.2936 172.359C60.1166 172.359 59.9731 172.215 59.9731 172.038V165.35C59.9731 165.173 60.1166 165.029 60.2936 165.029C60.4691 165.033 60.6106 165.174 60.614 165.35V172.025C60.6175 172.113 60.5853 172.198 60.5248 172.26C60.4643 172.323 60.3808 172.359 60.2936 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M63.2667 172.359C63.0897 172.359 62.9463 172.215 62.9463 172.038V165.35C62.9497 165.174 63.0912 165.033 63.2667 165.029C63.4437 165.029 63.5871 165.173 63.5871 165.35V172.025C63.5906 172.113 63.5584 172.198 63.4979 172.26C63.4375 172.323 63.354 172.359 63.2667 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M66.2467 172.359C66.0697 172.359 65.9263 172.215 65.9263 172.038V165.35C65.9263 165.173 66.0697 165.029 66.2467 165.029C66.4222 165.033 66.5637 165.174 66.5671 165.35V172.025C66.5706 172.113 66.5384 172.198 66.4779 172.26C66.4174 172.323 66.3339 172.359 66.2467 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    x: 72.8091,
    y: 165.35,
    width: 12.1761,
    height: 6.67547,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8028 172.359H84.9789C85.0662 172.359 85.1497 172.323 85.2101 172.26C85.2706 172.198 85.3028 172.113 85.2993 172.025V165.35C85.2959 165.174 85.1544 165.033 84.9789 165.029H72.8028C72.6273 165.033 72.4858 165.174 72.4824 165.35V172.038C72.4824 172.215 72.6259 172.359 72.8028 172.359ZM84.6521 171.718H73.1169V165.683H84.6521V171.718Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M75.9234 172.359C75.7465 172.359 75.603 172.215 75.603 172.038V165.35C75.603 165.173 75.7465 165.029 75.9234 165.029C76.099 165.033 76.2405 165.174 76.2439 165.35V172.025C76.2474 172.113 76.2152 172.198 76.1547 172.26C76.0942 172.323 76.0107 172.359 75.9234 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M78.8971 172.359C78.7201 172.359 78.5767 172.215 78.5767 172.038V165.35C78.5801 165.174 78.7215 165.033 78.8971 165.029C79.074 165.029 79.2175 165.173 79.2175 165.35V172.025C79.221 172.113 79.1888 172.198 79.1283 172.26C79.0678 172.323 78.9843 172.359 78.8971 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M81.8771 172.359C81.7001 172.359 81.5566 172.215 81.5566 172.038V165.35C81.5566 165.173 81.7001 165.029 81.8771 165.029C82.054 165.029 82.1975 165.173 82.1975 165.35V172.025C82.201 172.113 82.1688 172.198 82.1083 172.26C82.0478 172.323 81.9643 172.359 81.8771 172.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M95.5528 36.8357C95.3759 36.8357 95.2324 36.6921 95.2324 36.515V30.9105C95.2324 30.7334 95.3759 30.5898 95.5528 30.5898C95.7284 30.5933 95.8699 30.7348 95.8733 30.9105V36.515C95.8699 36.6907 95.7284 36.8323 95.5528 36.8357Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    x: 92.9443,
    y: 63.916,
    width: 5.21648,
    height: 3.61027,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9447 67.8341H98.1612C98.2405 67.8324 98.3158 67.7988 98.3701 67.7409C98.4244 67.683 98.453 67.6056 98.4496 67.5263V63.916C98.4496 63.7566 98.3204 63.6274 98.1612 63.6274H92.9447C92.7844 63.6274 92.6534 63.7556 92.6499 63.916V67.5391C92.6533 67.7006 92.7833 67.8307 92.9447 67.8341ZM97.8664 67.2441H93.2395V64.211H97.8664V67.2441Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    x: 91.9189,
    y: 61.5884,
    width: 7.26718,
    height: 2.33417,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9191 64.2366H99.1862C99.2712 64.2366 99.3527 64.2028 99.4128 64.1427C99.4729 64.0826 99.5067 64.001 99.5067 63.916V61.5882C99.5067 61.4111 99.3632 61.2676 99.1862 61.2676H91.9191C91.7421 61.2676 91.5986 61.4111 91.5986 61.5882V63.916C91.5986 64.093 91.7421 64.2366 91.9191 64.2366ZM98.8658 63.5953H92.2395V61.9088H98.8658V63.5953Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M94.1494 41.4272H96.9563L97.5202 61.5883H93.5854L94.1494 41.4272Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5854 61.8769H97.5202C97.5923 61.8737 97.6607 61.844 97.7124 61.7936C97.7646 61.7353 97.7942 61.6602 97.7957 61.582L97.251 41.4209C97.2475 41.2605 97.1166 41.1323 96.9562 41.1323H94.1493C93.989 41.1323 93.858 41.2605 93.8545 41.4209L93.2906 61.582C93.289 61.6608 93.319 61.737 93.3739 61.7936C93.4291 61.8505 93.5062 61.8809 93.5854 61.8769ZM97.219 61.2934H93.8866L94.4313 41.7223H96.6678L97.219 61.2934Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M98.4685 49.9881C98.4685 50.3728 98.1609 50.7255 97.6546 50.982H93.4442C92.938 50.7255 92.6304 50.3728 92.6304 49.9881C92.6805 49.5666 92.9554 49.2057 93.3481 49.0454H97.7956C98.1692 49.2202 98.4244 49.5777 98.4685 49.9881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4444 51.3022H97.6547C97.703 51.3147 97.7538 51.3147 97.8021 51.3022C98.3482 51.0976 98.7309 50.6003 98.789 50.0197C98.7425 49.4833 98.4088 49.0143 97.9175 48.7949C97.8682 48.7686 97.8131 48.7553 97.7572 48.7564H93.3482C93.2924 48.7553 93.2373 48.7686 93.188 48.7949C92.6941 49.0125 92.3577 49.4818 92.3101 50.0197C92.3693 50.6019 92.7547 51.0995 93.3034 51.3022C93.3495 51.3147 93.3982 51.3147 93.4444 51.3022ZM97.5778 50.6609H93.5277C93.1624 50.4621 92.9509 50.3147 92.9509 50.0197C92.9509 49.7247 93.2265 49.5067 93.4315 49.3784H97.6739C97.9751 49.59 98.1482 49.8209 98.1482 50.0197C98.1482 50.2185 97.9431 50.4621 97.5778 50.6609Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M94.566 35.9893H96.5398L96.6552 41.4271H94.4507L94.566 35.9893Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4504 41.7476H96.6549C96.732 41.739 96.8041 41.7052 96.86 41.6514C96.9173 41.5882 96.9493 41.506 96.9497 41.4206L96.8344 35.9827C96.8344 35.8983 96.8004 35.8174 96.7401 35.7583C96.6798 35.6991 96.5983 35.6668 96.5139 35.6685H94.5658C94.4814 35.6668 94.3998 35.6991 94.3396 35.7583C94.2793 35.8174 94.2453 35.8983 94.2453 35.9827L94.13 41.4206C94.1278 41.5065 94.1601 41.5896 94.2197 41.6514C94.2808 41.7128 94.3638 41.7474 94.4504 41.7476ZM96.3281 41.1064H94.7772L94.8798 36.3098H96.2256L96.3281 41.1064Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M88.8624 67.3789H102.237C102.842 67.3789 103.333 67.8698 103.333 68.4755V70.2453H87.7729V68.4755C87.7729 67.8723 88.2597 67.3824 88.8624 67.3789V67.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7731 70.5658H103.333C103.51 70.5658 103.653 70.4222 103.653 70.2451V68.4753C103.653 67.6926 103.019 67.0581 102.237 67.0581H88.8625C88.0828 67.0616 87.4526 67.6951 87.4526 68.4753V70.2451C87.4526 70.4222 87.5961 70.5658 87.7731 70.5658ZM103.012 69.9245H88.0935V68.4753C88.0935 68.0492 88.4367 67.7029 88.8625 67.6994H102.237C102.443 67.6994 102.64 67.7811 102.785 67.9266C102.931 68.0721 103.012 68.2695 103.012 68.4753V69.9245Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    x: 92.3613,
    y: 81.5186,
    width: 6.38282,
    height: 90.5068,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3356 172.359H98.744C98.8313 172.359 98.9148 172.323 98.9752 172.26C99.0357 172.197 99.0679 172.112 99.0644 172.025V81.5184C99.061 81.3427 98.9195 81.2012 98.744 81.1978H92.3356C92.1586 81.1978 92.0151 81.3413 92.0151 81.5184V172.038C92.0151 172.215 92.1586 172.359 92.3356 172.359ZM98.4364 171.717H92.6688V81.839H98.4364V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M97.8852 84.3463H93.2135C93.0365 84.3463 92.8931 84.2028 92.8931 84.0257C92.8965 83.8501 93.038 83.7085 93.2135 83.7051H97.8852C98.0622 83.7051 98.2057 83.8486 98.2057 84.0257C98.2057 84.2028 98.0622 84.3463 97.8852 84.3463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M97.9111 85.7892H93.1944C93.0175 85.7892 92.874 85.6457 92.874 85.4686C92.874 85.2915 93.0175 85.1479 93.1944 85.1479H97.9111C98.088 85.1479 98.2315 85.2915 98.2315 85.4686C98.2315 85.6457 98.088 85.7892 97.9111 85.7892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M97.93 87.3024H93.1686C92.993 87.299 92.8516 87.1574 92.8481 86.9818C92.8481 86.8047 92.9916 86.6611 93.1686 86.6611H97.93C98.107 86.6611 98.2505 86.8047 98.2505 86.9818C98.2505 87.1588 98.107 87.3024 97.93 87.3024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M97.9559 88.8224H93.1495C92.9726 88.8224 92.8291 88.6789 92.8291 88.5018C92.8291 88.3247 92.9726 88.1812 93.1495 88.1812H97.9559C98.1328 88.1812 98.2763 88.3247 98.2763 88.5018C98.2763 88.6789 98.1328 88.8224 97.9559 88.8224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M97.9817 90.3742H93.1241C92.9472 90.3742 92.8037 90.2306 92.8037 90.0535C92.8037 89.8765 92.9472 89.7329 93.1241 89.7329H97.9817C98.1587 89.7329 98.3022 89.8765 98.3022 90.0535C98.3022 90.2306 98.1587 90.3742 97.9817 90.3742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M98.0071 91.9518H93.0983C92.9213 91.9518 92.7778 91.8083 92.7778 91.6312C92.7778 91.4541 92.9213 91.3105 93.0983 91.3105H98.0071C98.1827 91.314 98.3241 91.4555 98.3276 91.6312C98.3276 91.8083 98.1841 91.9518 98.0071 91.9518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M98.033 93.5675H93.0729C92.8959 93.5675 92.7524 93.424 92.7524 93.2469C92.7524 93.0698 92.8959 92.9263 93.0729 92.9263H98.033C98.21 92.9263 98.3534 93.0698 98.3534 93.2469C98.3534 93.424 98.21 93.5675 98.033 93.5675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M98.0584 95.2155H93.047C92.87 95.2155 92.7266 95.0719 92.7266 94.8948C92.7266 94.7178 92.87 94.5742 93.047 94.5742H98.0584C98.2354 94.5742 98.3788 94.7178 98.3788 94.8948C98.3788 95.0719 98.2354 95.2155 98.0584 95.2155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    d: "M98.0843 96.8957H93.0216C92.8446 96.8957 92.7012 96.7521 92.7012 96.575C92.7012 96.3979 92.8446 96.2544 93.0216 96.2544H98.0843C98.2598 96.2578 98.4013 96.3994 98.4047 96.575C98.4047 96.7521 98.2612 96.8957 98.0843 96.8957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M98.1098 98.6144H92.983C92.8061 98.6144 92.6626 98.4709 92.6626 98.2938C92.6626 98.1167 92.8061 97.9731 92.983 97.9731H98.1098C98.2867 97.9731 98.4302 98.1167 98.4302 98.2938C98.4302 98.4709 98.2867 98.6144 98.1098 98.6144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    d: "M98.1355 100.365H92.9703C92.7934 100.365 92.6499 100.221 92.6499 100.044C92.6499 99.8672 92.7934 99.7236 92.9703 99.7236H98.1355C98.3125 99.7236 98.456 99.8672 98.456 100.044C98.456 100.221 98.3125 100.365 98.1355 100.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M98.161 102.16H92.9381C92.7626 102.157 92.6211 102.015 92.6177 101.84C92.6177 101.663 92.7611 101.519 92.9381 101.519H98.161C98.3379 101.519 98.4814 101.663 98.4814 101.84C98.4814 102.017 98.3379 102.16 98.161 102.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    d: "M98.1928 103.988H92.9122C92.7353 103.988 92.5918 103.844 92.5918 103.667C92.5918 103.49 92.7353 103.347 92.9122 103.347H98.1928C98.3683 103.35 98.5098 103.492 98.5132 103.667C98.5132 103.844 98.3697 103.988 98.1928 103.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M98.2187 105.86H92.8805C92.7049 105.857 92.5635 105.716 92.5601 105.54C92.5601 105.363 92.7035 105.219 92.8805 105.219H98.2187C98.3957 105.219 98.5391 105.363 98.5391 105.54C98.5391 105.717 98.3957 105.86 98.2187 105.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    d: "M98.2505 107.771H92.8546C92.6776 107.771 92.5342 107.628 92.5342 107.451C92.5342 107.273 92.6776 107.13 92.8546 107.13H98.2505C98.4275 107.13 98.5709 107.273 98.5709 107.451C98.5709 107.628 98.4275 107.771 98.2505 107.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M98.2829 109.727H92.8229C92.6459 109.727 92.5024 109.584 92.5024 109.407C92.5024 109.229 92.6459 109.086 92.8229 109.086H98.2829C98.4598 109.086 98.6033 109.229 98.6033 109.407C98.5999 109.582 98.4584 109.724 98.2829 109.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    d: "M98.3147 111.728H92.7906C92.6137 111.728 92.4702 111.584 92.4702 111.407C92.4702 111.23 92.6137 111.086 92.7906 111.086H98.3147C98.4917 111.086 98.6351 111.23 98.6351 111.407C98.6317 111.583 98.4903 111.724 98.3147 111.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    d: "M98.3402 113.767H92.7584C92.5814 113.767 92.438 113.624 92.438 113.447C92.4414 113.271 92.5829 113.129 92.7584 113.126H98.3402C98.5171 113.126 98.6606 113.27 98.6606 113.447C98.6606 113.624 98.5171 113.767 98.3402 113.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    d: "M98.3789 115.864H92.7267C92.5497 115.864 92.4062 115.72 92.4062 115.543C92.4062 115.366 92.5497 115.223 92.7267 115.223H98.3789C98.5559 115.223 98.6993 115.366 98.6993 115.543C98.6959 115.719 98.5545 115.861 98.3789 115.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    d: "M98.4367 118.006H92.6691C92.4921 118.006 92.3486 117.862 92.3486 117.685C92.3486 117.508 92.4921 117.365 92.6691 117.365H98.4367C98.6136 117.365 98.7571 117.508 98.7571 117.685C98.7537 117.861 98.6122 118.003 98.4367 118.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    d: "M98.4367 120.199H92.6691C92.4921 120.199 92.3486 120.055 92.3486 119.878C92.3486 119.701 92.4921 119.558 92.6691 119.558H98.4367C98.6136 119.558 98.7571 119.701 98.7571 119.878C98.7571 120.055 98.6136 120.199 98.4367 120.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    d: "M98.475 122.444H92.6241C92.4486 122.44 92.3071 122.299 92.3037 122.123C92.3037 121.946 92.4472 121.802 92.6241 121.802H98.475C98.652 121.802 98.7955 121.946 98.7955 122.123C98.7955 122.3 98.652 122.444 98.475 122.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    d: "M98.5133 124.739H92.5919C92.4149 124.739 92.2715 124.595 92.2715 124.418C92.2715 124.241 92.4149 124.098 92.5919 124.098H98.5133C98.6903 124.098 98.8337 124.241 98.8337 124.418C98.8337 124.595 98.6903 124.739 98.5133 124.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    x: 92.5537,
    y: 126.458,
    width: 5.99831,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    x: 92.5151,
    y: 128.875,
    width: 6.07521,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    x: 92.4766,
    y: 131.35,
    width: 6.1457,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    x: 92.438,
    y: 133.89,
    width: 6.22901,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    x: 92.3999,
    y: 136.493,
    width: 6.30592,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    x: 92.355,
    y: 139.167,
    width: 6.38923,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    x: 92.3164,
    y: 141.918,
    width: 6.47894,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    x: 92.2715,
    y: 144.733,
    width: 6.56225,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    x: 92.2266,
    y: 147.632,
    width: 6.65197,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    x: 92.1816,
    y: 150.607,
    width: 6.7481,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    x: 92.1304,
    y: 153.672,
    width: 6.83782,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    x: 92.0791,
    y: 156.821,
    width: 6.94035,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    x: 92.0347,
    y: 160.06,
    width: 7.03648,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    x: 91.9834,
    y: 163.394,
    width: 7.13901,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    x: 91.9253,
    y: 166.831,
    width: 7.24796,
    height: 0.641256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    d: "M92.6691 172.025C95.0146 141.803 95.1428 81.5186 95.1428 81.5186H92.5281C88.8304 151.249 85.2802 168.088 84.0049 172.025H92.6691Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9919 172.32H92.6689C92.8126 172.312 92.9291 172.201 92.9445 172.057C95.2643 142.168 95.4246 82.1341 95.4246 81.5313C95.4232 81.4549 95.3935 81.3818 95.3412 81.3261C95.2854 81.2694 95.2093 81.2371 95.1298 81.2363H92.5151C92.3597 81.2396 92.2335 81.363 92.2267 81.5185C88.5547 150.704 85.0493 167.799 83.7163 171.936C83.6867 172.024 83.701 172.122 83.7548 172.198C83.8106 172.274 83.8982 172.319 83.9919 172.32ZM92.3934 171.73H84.402L84.3892 171.717C85.8119 166.953 89.2276 148.902 92.7971 81.8135H94.835C94.8222 86.4305 94.5915 142.861 92.3934 171.73Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    d: "M107.107 172.025C105.825 168.082 102.282 151.249 98.5839 81.5186H95.9692C95.9692 81.5186 96.1038 141.797 98.4493 172.025H107.107Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4364 172.32H107.107C107.199 172.315 107.283 172.265 107.331 172.186C107.387 172.11 107.404 172.013 107.376 171.923C106.037 167.8 102.538 150.704 98.8658 81.5058C98.8589 81.3479 98.7289 81.2235 98.571 81.2236H95.9563C95.8787 81.2247 95.8048 81.2571 95.7513 81.3134C95.699 81.3691 95.6693 81.4422 95.668 81.5186C95.668 82.1214 95.8218 142.156 98.148 172.045C98.1549 172.199 98.282 172.321 98.4364 172.32ZM106.71 171.718H98.7184C96.5139 142.861 96.2768 86.4306 96.264 81.8008H98.3083C101.871 148.889 105.293 166.94 106.71 171.718Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    d: "M87.773 78.6519H103.333V80.4217C103.333 81.0273 102.842 81.5183 102.237 81.5183H88.8624C88.2572 81.5183 87.7666 81.0273 87.7666 80.4217V78.6519L87.773 78.6519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8625 81.8392H102.237C103.019 81.8392 103.653 81.2047 103.653 80.422V78.6522C103.653 78.4751 103.51 78.3315 103.333 78.3315H87.7731C87.5961 78.3315 87.4526 78.4751 87.4526 78.6522V80.422C87.4526 81.2022 88.0828 81.8357 88.8625 81.8392ZM88.0935 80.422V78.9728H103.012V80.422C103.012 80.8506 102.665 81.198 102.237 81.198H88.8625C88.4367 81.1944 88.0935 80.8481 88.0935 80.422Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    x: 85.6709,
    y: 68.8149,
    width: 19.7573,
    height: 10.818,
    rx: 3.18,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.715 79.9215H103.39C104.678 79.9215 105.723 78.8765 105.723 77.5874V70.8542C105.723 69.5651 104.678 68.52 103.39 68.52H87.715C86.4267 68.52 85.3823 69.5651 85.3823 70.8542V77.5874C85.3823 78.8765 86.4267 79.9215 87.715 79.9215ZM86.4783 69.625C86.8066 69.2977 87.2516 69.1147 87.715 69.1164H103.39C104.351 69.1164 105.133 69.8924 105.14 70.8542V77.5938C105.14 78.5606 104.356 79.3444 103.39 79.3444H87.715C86.7488 79.3444 85.9655 78.5606 85.9655 77.5938V70.8606C85.9655 70.3969 86.15 69.9523 86.4783 69.625Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    d: "M106.018 71.8737H85.0875C84.9105 71.8737 84.7671 71.7301 84.7671 71.553C84.7671 71.376 84.9105 71.2324 85.0875 71.2324H106.018C106.194 71.2324 106.338 71.376 106.338 71.553C106.338 71.7301 106.194 71.8737 106.018 71.8737Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    d: "M106.018 74.5416H85.0875C84.9105 74.5416 84.7671 74.3981 84.7671 74.221C84.7671 74.0439 84.9105 73.9004 85.0875 73.9004H106.018C106.193 73.9038 106.335 74.0454 106.338 74.221C106.338 74.3981 106.194 74.5416 106.018 74.5416Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M106.018 77.2091H85.0875C84.9105 77.2091 84.7671 77.0656 84.7671 76.8885C84.7671 76.7114 84.9105 76.5679 85.0875 76.5679H106.018C106.193 76.5713 106.335 76.7129 106.338 76.8885C106.338 77.0656 106.194 77.2091 106.018 77.2091Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    d: "M134.497 122.559C134.32 122.559 134.176 122.415 134.176 122.238V111.189C134.176 111.012 134.32 110.869 134.497 110.869C134.674 110.869 134.817 111.012 134.817 111.189V122.238C134.817 122.415 134.674 122.559 134.497 122.559Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    x: 131.209,
    y: 123.758,
    width: 13.1565,
    height: 48.2673,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.209 172.358H144.366C144.453 172.358 144.536 172.323 144.597 172.26C144.657 172.197 144.69 172.112 144.686 172.025V123.758C144.686 123.581 144.543 123.437 144.366 123.437H131.209C131.032 123.437 130.889 123.581 130.889 123.758V172.038C130.889 172.215 131.032 172.358 131.209 172.358ZM144.064 171.717H131.549L131.53 124.078H144.064V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    x: 131.209,
    y: 121.257,
    width: 6.57507,
    height: 2.5009,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.209 124.079H137.784C137.961 124.079 138.105 123.935 138.105 123.758V121.257C138.105 121.08 137.961 120.937 137.784 120.937H131.209C131.032 120.937 130.889 121.08 130.889 121.257V123.758C130.889 123.935 131.032 124.079 131.209 124.079ZM137.464 123.437H131.53V121.578H137.464V123.437Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    x: 143.392,
    y: 78.1709,
    width: 39.4632,
    height: 93.8542,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.392 77.5298H182.855C183.209 77.5298 183.496 77.8169 183.496 78.171V172.025C183.496 172.379 183.209 172.666 182.855 172.666H143.392C143.038 172.666 142.751 172.379 142.751 172.025V78.171C142.751 77.8169 143.038 77.5298 143.392 77.5298ZM182.855 172.025V78.171H143.392V172.025H182.855Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    x: 143.392,
    y: 85.167,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    x: 143.392,
    y: 92.7212,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    x: 143.392,
    y: 100.282,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    x: 143.392,
    y: 107.835,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    x: 143.392,
    y: 115.396,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    x: 143.392,
    y: 122.95,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    x: 143.392,
    y: 130.51,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    x: 143.392,
    y: 138.064,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    x: 143.392,
    y: 145.618,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    x: 143.392,
    y: 153.179,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    x: 143.392,
    y: 160.732,
    width: 39.4632,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    x: 153.806,
    y: 71.1045,
    width: 18.6358,
    height: 100.921,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.806 172.359H172.442C172.529 172.359 172.612 172.323 172.673 172.26C172.733 172.197 172.765 172.112 172.762 172.025V71.1043C172.762 70.9272 172.619 70.7837 172.442 70.7837H153.806C153.629 70.7837 153.485 70.9272 153.485 71.1043V172.038C153.485 172.215 153.629 172.359 153.806 172.359ZM172.134 171.717H154.126V71.4249H172.134V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    d: "M172.442 81.9415H153.806C153.629 81.9415 153.485 81.798 153.485 81.6209C153.485 81.4438 153.629 81.3003 153.806 81.3003H172.442C172.619 81.3003 172.762 81.4438 172.762 81.6209C172.762 81.798 172.619 81.9415 172.442 81.9415Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    d: "M172.442 89.4699H153.806C153.629 89.4699 153.485 89.3263 153.485 89.1492C153.485 88.9722 153.629 88.8286 153.806 88.8286H172.442C172.619 88.8286 172.762 88.9722 172.762 89.1492C172.762 89.3263 172.619 89.4699 172.442 89.4699Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    d: "M172.442 97.0241H153.806C153.629 97.0241 153.485 96.8805 153.485 96.7034C153.485 96.5264 153.629 96.3828 153.806 96.3828H172.442C172.619 96.3828 172.762 96.5264 172.762 96.7034C172.762 96.8805 172.619 97.0241 172.442 97.0241Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    d: "M172.442 104.584H153.806C153.629 104.584 153.485 104.441 153.485 104.263C153.485 104.086 153.629 103.943 153.806 103.943H172.442C172.619 103.943 172.762 104.086 172.762 104.263C172.762 104.441 172.619 104.584 172.442 104.584Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    d: "M172.442 112.138H153.806C153.629 112.138 153.485 111.995 153.485 111.818C153.485 111.641 153.629 111.497 153.806 111.497H172.442C172.619 111.497 172.762 111.641 172.762 111.818C172.762 111.995 172.619 112.138 172.442 112.138Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    d: "M172.442 119.699H153.806C153.629 119.699 153.485 119.555 153.485 119.378C153.485 119.201 153.629 119.058 153.806 119.058H172.442C172.619 119.058 172.762 119.201 172.762 119.378C172.762 119.555 172.619 119.699 172.442 119.699Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    d: "M172.442 127.253H153.806C153.629 127.253 153.485 127.109 153.485 126.932C153.485 126.755 153.629 126.611 153.806 126.611H172.442C172.619 126.611 172.762 126.755 172.762 126.932C172.762 127.109 172.619 127.253 172.442 127.253Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    d: "M172.442 134.807H153.806C153.629 134.807 153.485 134.663 153.485 134.486C153.485 134.309 153.629 134.166 153.806 134.166H172.442C172.619 134.166 172.762 134.309 172.762 134.486C172.762 134.663 172.619 134.807 172.442 134.807Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    d: "M172.442 142.367H153.806C153.629 142.367 153.485 142.224 153.485 142.047C153.485 141.87 153.629 141.726 153.806 141.726H172.442C172.619 141.726 172.762 141.87 172.762 142.047C172.762 142.224 172.619 142.367 172.442 142.367Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    d: "M172.442 149.915H153.806C153.629 149.915 153.485 149.771 153.485 149.594C153.485 149.417 153.629 149.273 153.806 149.273H172.442C172.619 149.273 172.762 149.417 172.762 149.594C172.762 149.771 172.619 149.915 172.442 149.915Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    d: "M172.442 157.482H153.806C153.629 157.482 153.485 157.338 153.485 157.161C153.485 156.984 153.629 156.84 153.806 156.84H172.442C172.619 156.84 172.762 156.984 172.762 157.161C172.762 157.338 172.619 157.482 172.442 157.482Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    x: 156.542,
    y: 68.1099,
    width: 13.1565,
    height: 3.02673,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.542 71.4635H169.699C169.876 71.4635 170.019 71.3199 170.019 71.1428V68.1097C170.019 67.9326 169.876 67.7891 169.699 67.7891H156.542C156.367 67.7925 156.225 67.934 156.222 68.1097V71.1428C156.225 71.3185 156.367 71.46 156.542 71.4635ZM169.378 70.8222H156.882L156.863 68.4303H169.378V70.8222Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    x: 134.606,
    y: 130.805,
    width: 2.42239,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    x: 137.938,
    y: 138.077,
    width: 2.42239,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    x: 134.305,
    y: 145.349,
    width: 2.42239,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    x: 135.516,
    y: 156.257,
    width: 2.42239,
    height: 0.641256,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    x: 113.112,
    y: 164.958,
    width: 72.4604,
    height: 7.06664,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.112 172.32H185.591C185.754 172.32 185.886 172.188 185.886 172.025V164.971C185.886 164.894 185.855 164.819 185.799 164.765C185.744 164.711 185.669 164.681 185.591 164.683H113.112C112.951 164.683 112.82 164.811 112.817 164.971V172.025C112.82 172.187 112.95 172.317 113.112 172.32ZM185.284 171.717H113.406V165.241H185.284V171.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M132.574 160.72C132.574 160.72 136.829 156.128 149.345 156.128C161.861 156.128 166.11 160.72 166.11 160.72H132.574Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.574 161.015H166.11C166.226 161.015 166.331 160.947 166.379 160.842C166.424 160.734 166.404 160.609 166.328 160.521C166.148 160.329 161.842 155.84 149.345 155.84C136.849 155.84 132.536 160.329 132.363 160.521C132.281 160.607 132.258 160.733 132.305 160.842C132.356 160.945 132.459 161.012 132.574 161.015ZM165.322 160.431H133.363C134.888 159.264 139.605 156.423 149.345 156.423C159.086 156.423 163.796 159.264 165.322 160.431Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.977 165.305H162.707C162.81 165.306 162.907 165.258 162.97 165.177L166.052 160.938C166.121 160.839 166.129 160.71 166.074 160.603C166.019 160.495 165.91 160.427 165.79 160.425H132.895C132.775 160.427 132.665 160.495 132.61 160.603C132.555 160.71 132.564 160.839 132.632 160.938L135.721 165.177C135.78 165.259 135.876 165.307 135.977 165.305ZM162.521 164.664H136.144L133.523 161.066H165.136L162.521 164.664Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    d: "M141.937 165.164L138.733 161.246L135.881 165.151L135.362 164.773L138.457 160.534C138.515 160.453 138.607 160.403 138.707 160.399C138.806 160.403 138.898 160.447 138.963 160.521L142.45 164.76L141.937 165.164Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    d: "M148.903 165.164L145.699 161.246L142.847 165.151L142.328 164.773L145.423 160.534C145.481 160.453 145.574 160.403 145.673 160.399C145.772 160.402 145.865 160.446 145.93 160.521L149.416 164.76L148.903 165.164Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    d: "M155.869 165.164L152.665 161.246L149.813 165.151L149.294 164.773L152.389 160.534C152.447 160.453 152.539 160.403 152.639 160.399C152.738 160.401 152.832 160.445 152.895 160.521L156.382 164.76L155.869 165.164Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    d: "M162.835 165.164L159.631 161.246L156.753 165.151L156.241 164.773L159.33 160.534C159.388 160.453 159.48 160.404 159.58 160.399C159.678 160.402 159.771 160.446 159.836 160.521L163.322 164.76L162.835 165.164Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    d: "M121.084 172.038H120.443C120.583 169.741 120.6 167.437 120.495 165.138C120.542 165.24 120.645 165.305 120.757 165.305V164.664L121.007 164.773C121.116 164.856 121.36 165.112 121.084 172.038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    d: "M130.594 172.038H129.953C130.096 169.741 130.113 167.437 130.004 165.138C130.054 165.241 130.159 165.306 130.274 165.305V164.664L130.517 164.773C130.62 164.856 130.87 165.112 130.594 172.038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    d: "M140.092 172.038H139.451C139.593 169.741 139.61 167.437 139.502 165.138C139.552 165.241 139.657 165.306 139.771 165.305V164.664L140.015 164.773C140.13 164.856 140.374 165.112 140.092 172.038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    d: "M149.602 172.038H148.961C149.104 169.741 149.121 167.437 149.012 165.138C149.062 165.241 149.167 165.306 149.281 165.305V164.664L149.525 164.773C149.634 164.856 149.877 165.112 149.602 172.038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    d: "M159.105 172.038H158.464C158.604 169.741 158.624 167.437 158.522 165.138C158.567 165.243 158.671 165.309 158.785 165.305V164.664L159.035 164.773C159.137 164.856 159.381 165.112 159.105 172.038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    d: "M168.609 172.038H167.968C168.112 169.741 168.131 167.437 168.026 165.138C168.071 165.243 168.175 165.309 168.289 165.305V164.664L168.539 164.773C168.641 164.856 168.885 165.112 168.609 172.038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    d: "M178.113 172.038H177.472C177.616 169.741 177.635 167.437 177.53 165.138C177.577 165.24 177.68 165.305 177.793 165.305V164.664L178.043 164.773C178.145 164.856 178.389 165.112 178.113 172.038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    x: 113.112,
    y: 166.76,
    width: 72.4604,
    height: 0.641256,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    d: "M191.359 172.628H10.6407C10.4638 172.628 10.3203 172.485 10.3203 172.307C10.3203 172.13 10.4638 171.987 10.6407 171.987H191.359C191.536 171.987 191.679 172.13 191.679 172.307C191.679 172.485 191.536 172.628 191.359 172.628Z",
    fill: "#231F20"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_575_2441",
    x1: 0,
    y1: 202,
    x2: 202,
    y2: 202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D0202",
    stopOpacity: 0.497569
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurImg1);
export default __webpack_public_path__ + "static/media/our-img1.67a77b0d75b1aff954bf7a7dbf6c436f.svg";
export { ForwardRef as ReactComponent };